<template>
    <v-container>
        <v-card class="cardSide" :loading="loading">
            <v-card-text style="height: 92%;">
                <v-row style="height: 85%;">
                    <v-col cols ="4" style="height: 100%;">
                        <v-form ref="form">
                            <v-card-title>
                                <span class="headline">{{ 'Cadastro de Situações' | translate('Situacoes')}}</span>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-row style="display: flex; justify-content: center">
                                    <v-col cols="10" >
                                        <v-row class="rowPadding">
                                            <v-col style="padding: 0em 3em;">
                                                <v-text-field
                                                    autofocus
                                                    :loading="loading"
                                                    v-model="editedItem.NOME"
                                                    :label="labels.nome"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col style="display: flex; justify-content: center; padding: 0;">
                                                <v-color-picker
                                                    elevation="1"
                                                    v-model="editedItem.COR"
                                                    dot-size="25"
                                                    mode="hexa"
                                                    style="height: 300px;"
                                                    swatches-max-height="160"
                                                ></v-color-picker>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="editedItem.NOME">
                                            <v-col cols="2" style="display: flex; justify-content: center; padding: 1em 0 0 0;">
                                                <v-btn
                                                    fab
                                                    dark
                                                    color="red"
                                                    @click="calcelEdit"
                                                    small
                                                > 
                                                    <v-icon>
                                                        mdi-window-close
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="8" style="display: flex; justify-content: center; min-width: 6em; padding: 1em 0 0 0;">
                                                <v-chip text-color="white" :color="editedItem.COR">{{editedItem.NOME}}</v-chip>
                                            </v-col>
                                            <v-col cols="2" style="display: flex; justify-content: center;">
                                                <v-btn 
                                                    fab
                                                    dark 
                                                    color="green"
                                                    @click="saveSituation"
                                                    small
                                                > 
                                                    <v-icon>
                                                        mdi-check
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-form>
                    </v-col>
                    <v-divider vertical inset />
                    <v-col style="height: 100%;">
                        <v-card-title>
                            <v-row>
                                <v-col cols="4">
                                    <span class="headline">{{ 'Nome' | translate('Situacoes')}} </span>
                                </v-col>
                                <v-col cols="1" style="text-align: center; padding-left: 0px;">
                                    <span class="headline">{{ 'Editar' | translate('Situacoes')}} </span>
                                </v-col>
                                <v-col cols="1" style="text-align: center; padding-left: 0px;">
                                    <span class="headline">{{ 'Inicial' | translate('Situacoes')}} </span>
                                </v-col>
                                <v-col cols="1" style="text-align: center; padding-left: 0px;">
                                    <span class="headline">{{ 'Ativo' | translate('Situacoes')}} </span>
                                </v-col>
                                <v-col cols="1" style="text-align: center; padding-left: 0px;">
                                    <span class="headline">{{ 'Final' | translate('Situacoes')}} </span>
                                </v-col>
                                <v-col cols="1" style="text-align: center; padding-left: 0px;">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span 
                                                class="headline"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{ 'PRC' | translate('Situacoes')}} 
                                            </span>
                                        </template>
                                        <span>{{ 'Pós resposta cliente' | translate('Situacoes')}}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="1" style="text-align: center; padding-left: 0px;">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span 
                                                class="headline"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{ 'ARC' | translate('Situacoes')}} 
                                            </span>
                                        </template>
                                        <span>{{ 'Aguardando resposta cliente' | translate('Situacoes')}}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="1" style="text-align: center; padding-left: 0px;">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span 
                                                class="headline"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{ 'EPE' | translate('Situacoes')}} 
                                            </span>
                                        </template>
                                        <span>{{ 'Em processo de entrega' | translate('Situacoes')}}</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="1" style="text-align: center; padding-left: 0px;">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span 
                                                class="headline"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                {{ 'ED' | translate('Situacoes')}} 
                                            </span>
                                        </template>
                                        <span>{{ 'Em desenvolvimento' | translate('Situacoes')}}</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-progress-circular
                            indeterminate
                            color="grey"
                            v-if="loading"
                            :size="50"
                            style="position: relative; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                        ></v-progress-circular>
                        <v-list two-line class="scrollList" v-if="!loading">
                            <draggable
                                v-model="situations"
                                tag="v-list-item-group"
                            >
                                <template v-for="(item, index) in situations">
                                    <v-list-item @click.stop class="py-0 dragItem" :key="item.ID" ref="item">
                                        <v-row style="align-items: center; border-bottom: 1px solid #dddddd;">
                                            <v-col style="display: contents; height:30px;" cols="4">
                                                <v-list-item-avatar style="margin:0;" :color="item.COR" size="30" class="px-1">
                                                    <span class="white--text headline">{{ index + 1 }}</span>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        class="px-3"
                                                        v-text="translateTerm(item.NOME, 'Situacoes')"
                                                    ></v-list-item-title>
                                                </v-list-item-content>
                                            </v-col>
                                            <v-col style="padding: 0px 0px 0px 20px; text-align: center;" cols="1">
                                                <v-list-item-action>
                                                    <v-btn 
                                                        icon
                                                        @click="editItem(item, index)" >
                                                        <v-icon>
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>
                                                </v-list-item-action>
                                            </v-col>
                                            <v-col style="padding: 0px 0px 0px 20px; text-align: center;" cols="1">
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        v-model="item.PADRAO"
                                                        :disabled="disableField(item, 'PADRAO')"
                                                        true-value="S"
                                                        false-value="N"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                            </v-col>
                                            <v-col style="padding: 0px 0px 0px 20px; text-align: center;" cols="1">
                                                <v-list-item-action>
                                                    <v-switch
                                                        v-model="item.ATIVO"
                                                        true-value="S"
                                                        false-value="N"
                                                        color="black"
                                                        :id="index.toString()"
                                                        inset
                                                    ></v-switch>
                                                </v-list-item-action>
                                            </v-col>
                                            <v-col style="padding: 0px 0px 0px 20px; text-align: center;" cols="1">
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        v-model="item.FINAL"
                                                        :disabled="disableField(item, 'FINAL')"
                                                        true-value="S"
                                                        false-value="N"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                            </v-col>
                                            <v-col style="padding: 0px 0px 0px 20px; text-align: center;" cols="1">
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        v-model="item.POS_RESPOSTA_CLIENTE"
                                                        :disabled="disableField(item, 'POS_RESPOSTA_CLIENTE')"
                                                        true-value="S"
                                                        false-value="N"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                            </v-col>
                                            <v-col style="padding: 0px 0px 0px 20px; text-align: center;" cols="1">
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        v-model="item.AGUARDANDO_RETORNO_CLIENTE"
                                                        :disabled="disableField(item, 'AGUARDANDO_RETORNO_CLIENTE')"
                                                        true-value="S"
                                                        false-value="N"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                            </v-col>
                                            <v-col style="padding: 0px 0px 0px 20px; text-align: center;" cols="1">
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        v-model="item.EM_PROCESSO_ENTREGA"
                                                        :disabled="disableField(item, 'EM_PROCESSO_ENTREGA')"
                                                        true-value="S"
                                                        false-value="N"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                            </v-col>
                                            <v-col style="padding: 0px 0px 0px 20px; text-align: center;" cols="1">
                                                <v-list-item-action>
                                                    <v-checkbox
                                                        v-model="item.EM_DESENVOLVIMENTO"
                                                        :disabled="disableField(item, 'EM_DESENVOLVIMENTO')"
                                                        true-value="S"
                                                        false-value="N"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </template>
                            </draggable>
                        </v-list>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row style="height: 15%; margin-top: 1.5em;">
                    <v-col cols="12">
                        <v-select
                            dense
                            v-model="editedItem.situations"
                            :items="suggestSituations"
                            label="Situações sugeridas"
                            clearable
                            item-text="NOME"
                            item-value="ID"
                            return-object
                            hide-selected
                            chips
                            multiple
                            :menu-props="{closeOnContentClick:true, top: true, offsetY: true}"
                            :disabled="!editedItem.ID"
                        >
                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                <v-chip
                                    :key="JSON.stringify(item.ID)"
                                    v-if="item === Object(item)"
                                    v-bind="attrs"
                                    :input-value="selected.value"
                                    @click:close="parent.selectItem(item.value)"
                                    class="kndChip"
                                >
                                    <v-avatar
                                        :color="item.COR"
                                        size="18"
                                        style="margin-right: 1em;"
                                    ></v-avatar>
                                    <span class="d-inline-block text-truncate">
                                        {{ item.NOME | translate('Situacoes') }}
                                    </span>
                                    <v-btn
                                        icon
                                        @click="parent.selectItem(item)"
                                    >
                                        <v-icon color="red">
                                            mdi-close-circle
                                        </v-icon>
                                    </v-btn>
                                </v-chip>
                            </template>
                            <template v-slot:[`item`]="{ item }">
                                <v-avatar
                                    :color="item.COR"
                                    size="18"
                                    style="margin-right: 1em;"
                                ></v-avatar>
                                <span class="d-block text-truncate">{{ item.NOME | translate('Situacoes') }}</span>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn 
                    class="white--text btn1" 
                    small
                    color="black"
                    @click="update(null)"
                    :disabled="!situations.length"
                >
                    {{'Salvar' | translate('Situacoes')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import getAllCallSituations from '../../../../../src/app/situacaoAtendimento/getAllCallSituationsQuantities'
import { createNamespacedHelpers } from 'vuex'
import translate from '../../../../../src/plugins/translate'
import addSituation from '../../../../../src/app/situacaoAtendimento/addSituation'
import updateSituation from '../../../../../src/app/situacaoAtendimento/updateSituation'


const user = createNamespacedHelpers('user')

export default {
    name: 'Situacoes',
    components: {draggable},
    data() {
        return {
            loading: false,
            editedItem: {COR:'#C2C2C2FF', situations: []},
            situations: [],
            tableHeaders:[
                {text:translate('Ordem', 'Situacoes'), align:'start', value:'ORDEM'},
                {text:translate('Nome', 'Situacoes'), align:'center', value:'NOME'},
                {text:translate('Editar', 'Situacoes'), align:'center', value:'EDITAR'},
                {text:translate('Ativo', 'Situacoes'), align:'start', value:'ATIVO'}
            ],
            labels: {
                nome: translate('Nome', 'Situacoes'),
                ordem: translate('Ordem', 'Situacoes')
            },
        }
    },
    methods: {
        async getAllSituations(){
            this.loading = true
            await getAllCallSituations({companyId:this.user.EMPRESA_ID})
                .then(onSuccess.bind(this))
                .finally(onFinally.bind(this))

            //#region Internal functions
            function onSuccess(response){
                this.situations = response.data.filter(function(situation){
                    return situation.ID
                })
                this.resetVariables()
            }
            function onFinally(){
                this.loading = false;
            }
            //#endregion
        },
        translateTerm(term, view){
            return translate(term, view)
        },
        checkMove(evt) {
            console.log(evt.draggedContext);
        },
        checkStart(evt) {
            this.evt = evt;
        },
        calcel() {
            this.editedItem = {}
        },
        editItem(item, index){
            this.bkpItem = Object.assign({},item)
            this.indexEdit = index
            this.editedItem = item
        },
        resetVariables(){
            this.indexEdit = null
            this.bkpItem = {}
            this.editedItem = {COR:'#C2C2C2FF', ORDEM: this.situations.length+1}
        },
        calcelEdit(){
            this.situations[this.indexEdit] = Object.assign(this.bkpItem)
            this.resetVariables()
        },
        async saveSituation(){
            this.loading = true
            if(this.editedItem.ID) this.update()
            else this.addNewSituation()
        },
        async addNewSituation(){
            this.editedItem.EMPRESA_ID = this.user.EMPRESA_ID
            await addSituation(this.editedItem)
                .then(function(){
                    this.getAllSituations()
                }.bind(this))
                .finally(this.loading = false)
        },
        async update(situation){
            this.loading = true
            await updateSituation(situation ? [situation] : this.situations)
                .then(function(){
                    this.getAllSituations()
                }.bind(this))
                .finally(this.loading = false)
        },
        disableField(item, field){
            var count = 0
            this.situations.filter(function(item){
                if(item[field] == 'S') count++
            })
            if(count < 1 || item[field] == 'S') return false
            return true
        },
    },
    computed:{
        ...user.mapGetters(['user']),
        suggestSituations(){
            const situations = JSON.parse(JSON.stringify(this.situations))
            return situations.map(s => {
                return Object.assign(s, { situations: [] })
            })
        }
    },
    async mounted() {
        this.loading = true
        await this.getAllSituations()
        this.resetVariables()
        this.loading = false
    },

}
</script>
<style scoped>
.headerPage{
    height: 2rem;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.headline{
    font-size: 14px !important;
}
.dragItem:hover{
    cursor: move;
}
.dragItem:active{
    cursor: move;
}
.rowPadding{
    justify-content: center;
}
.draggable-flex {
  display: inherit;
  flex-direction: inherit;
}
.scrollList{
    overflow-y: auto;
    overflow-x: hidden;
    height: 84%;
    max-height: 84%;
}
.scrollList::-webkit-scrollbar {
    width: 8px;
}

.scrollList::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.scrollList::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.cardSide{
    height: 700px;
}

::v-deep .v-card__title {
    line-height: 0;
}

.kndChip{
    padding: 0px 0px 0px 8px; 
    margin: 0;
    height: 30px; 
    margin: 0px 1px 3px 1px !important;
}
</style>
